import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onActivated,
  onDeactivated,
  onMounted,
  PropType,
  ref,
} from "vue";
import CardSwiper from "./CardSwiper.vue";
import MainCardButton from "./MainCardButton.vue";
import NoFavoriteCard from "./NoFavoriteCard.vue";
import { LineTypeCode, RouterName } from "@/types";
import { useRouter } from "vue-router";
import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { IOnBoardLine } from "@/domain/entities/onBoardLine";

import { IBusStop } from "@/domain/entities/busStop";
import ReportModal from "../shared/modal/ReportModal.vue";
import BusInfoModal from "../shared/modal/BusInfoModal.vue";
import useGetLineRouteName from "@/use/useGetLineRouteName";


const __default__ = {
  name: "FavoriteCardsView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  cardUpdateKey: {
    type: Number,
    required: true,
  },
  allCardsUpdateKey: {
    type: Number,
    required: true,
  },
  favoriteLines: {
    type: Array as PropType<IFavoriteLine[]>,
    required: true,
  },
  currentFavoriteLine: {
    type: Object as PropType<IFavoriteLine>,
  },
  onBoardLine: {
    type: Object as PropType<IOnBoardLine>,
  },
  isBusRunning: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickBusStopLocation", "showTimeTable", "getBusLocation", "goToLineInfoDetail", "setIntervalBusLocation", "onChangedCheck", "updateBusLocation", "updateCurrentFavoriteLine"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClickBusStopLocation = (busStop: IBusStop) => {
  emit("onClickBusStopLocation", busStop);
};

const emitOnShowTimeTable = (busStop: IBusStop) => {
  emit("showTimeTable", busStop);
};

const emitUpdateCurrentFavoriteLine = (favoriteLine: IFavoriteLine) => {
  emit("updateCurrentFavoriteLine", favoriteLine);
};

const router = useRouter();

const lineName = computed(() =>
  useGetLineRouteName(
    props.currentFavoriteLine?.lineTypeCode,
    props.currentFavoriteLine?.routeName,
    props.currentFavoriteLine?.lineNum
  )
);

/** 현재 선택된 카드 */
const currentCardIndex = ref(0);

const isInsideShuttle = computed(
  () => props.currentFavoriteLine?.lineTypeCode === LineTypeCode.Inside
);

// 메인카드 버튼 처리
const shouldShowFront = ref(true);
const updateShowFront = (show: boolean) => {
  shouldShowFront.value = show;
};

const cardSwiper = ref<typeof CardSwiper>();
const onClickMainCardButton = () => {
  if (isInsideShuttle.value) return;
  cardSwiper.value?.closeTooltip();
  shouldShowFront.value = !shouldShowFront.value;
  if (!shouldShowFront.value) {
    emit("getBusLocation");
  }
};

const onSlideChange = (index: number) => {
  shouldShowFront.value = true;
  currentCardIndex.value = index;
  emitUpdateCurrentFavoriteLine(props.favoriteLines[currentCardIndex.value]);
  emit("setIntervalBusLocation");
};

const onChangedCheck = (checked: boolean) => {
  if (!props.currentFavoriteLine) return;

  emit("onChangedCheck", checked);
};

// 신고하기 모달 처리
const shouldShowReportModal = ref(false);
const toggleShowReportModal = (show: boolean) => {
  shouldShowReportModal.value = show;
};

// 버스 사진 모달 처리
const shouldShowBusImage = ref(false);
const toggleShowBusImage = (show: boolean) => {
  shouldShowBusImage.value = show;
};

/** 노선 검색 페이지 이동 */
const goToSearch = () => {
  router.push({ name: RouterName.LineSearch });
};

/** LifeCycle */
const isCalledOnMounted = ref(false);
const updateIsCalledOnMounted = (called: boolean) => {
  isCalledOnMounted.value = called;
};

onMounted(() => {
  updateIsCalledOnMounted(true);
  updateShowFront(true);
  emitUpdateCurrentFavoriteLine(props.favoriteLines[currentCardIndex.value]);
});

onActivated(() => {
  if (isCalledOnMounted.value) return;
  updateShowFront(true);
  emitUpdateCurrentFavoriteLine(props.favoriteLines[currentCardIndex.value]);
});

onDeactivated(() => {
  isCalledOnMounted.value = false;
});

const __returned__ = { props, emit, emitOnClickBusStopLocation, emitOnShowTimeTable, emitUpdateCurrentFavoriteLine, router, lineName, currentCardIndex, isInsideShuttle, shouldShowFront, updateShowFront, cardSwiper, onClickMainCardButton, onSlideChange, onChangedCheck, shouldShowReportModal, toggleShowReportModal, shouldShowBusImage, toggleShowBusImage, goToSearch, isCalledOnMounted, updateIsCalledOnMounted, CardSwiper, MainCardButton, NoFavoriteCard, ReportModal, BusInfoModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})